import { SortTypeEnum } from '@/request/request.enum';
import { IBaseReq } from '../request.interface';

export enum TokenTimeRange {
  '1h' = '1h',
  '6h' = '6h',
  '24h' = '24h',
  '1m' = '1m',
  '5m' = '5m',
}

export enum DevStatus {
  HOLD = 'HOLD',
  SELL_ALL = 'SELL_ALL',
  ADD = 'ADD',
}

export enum SortBy {
  AGE = 'age',
  LIQ = 'liq',
  MC = 'mc',
  HOLDERS = 'holders',
  TXS = 'txs',
  VOL = 'vol',
  PRICE = 'price',
  PRICE_CHANGE1M = 'priceChange1m',
  PRICE_CHANGE5M = 'priceChange5m',
  PRICE_CHANGE = 'priceChange',
}

// 获取token趋势列表
export interface ITrendingReq extends IBaseReq {
  timeRange?: TokenTimeRange;
  // 过滤风险代币
  filterRisk?: boolean;
  // 最小时间(小时)
  minAge?: number;
  // 最大时间(小时)
  minMaxAge?: number;
  // 最小流动性
  minLiquidity?: number;
  // 最大流动性
  minMaxLiquidity?: number;
  // 最小市值
  minMarketCap?: number;
  // 最大市值
  minMaxMarketCap?: number;
  // 最小持有人数
  minHolders?: number;
  // 最大持有人数
  minMaxHolders?: number;
  // 最小交易数
  minTxs?: number;
  // 最大交易数
  minMaxTxs?: number;
  // 最小交易量
  minVolume?: number;
  // 最大交易量
  minMaxVolume?: number;
  // 是否无法铸造
  isNoMint?: boolean;
  // 是否在黑名单
  isBlacklist?: boolean;
  // 是否已销毁
  isBurnt?: boolean;
  // 是否为Top10
  isTop10?: boolean;
  // 最小内部人员持有比例
  minInsiders?: number;
  // 最大内部人员持有比例
  maxInsiders?: number;
  developerStatus?: DevStatus[];
  // 是否关注
  isFollow?: boolean;
  sortBy?: SortBy;
  sort?: SortTypeEnum;
  tab: 'trending' | 'new';
}

// 获取token详情
export interface ITokenInfoReq {
  address: string;
}

// 获取热门代币列表
export interface IHotTokensReq extends IBaseReq {}

// 搜索代币
export interface iSearchTokenReq extends IBaseReq {
  query: string;
}

export interface ITokenPositionForAddressReq extends IBaseReq {
  tokenAddress: string;
  walletAddress?: string;
}

export interface ITokenActivityReq extends IBaseReq {
  tokenAddress: string;
  walletAddress?: string;
  sortBy?: 'price' | 'time';
  sort?: SortTypeEnum;
}

export interface ITokenOrderReq extends IBaseReq {
  walletAddress: string;
  tokenAddress: string;
}
